import { Megaphone, Video, Mic, CalendarDays, Eye, Target, BarChart3, Zap, ShieldCheck, PenTool, Users, Bot } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const FEATURE_ICONS = [Megaphone, Video, Mic, CalendarDays, Eye, Target, BarChart3, Zap, ShieldCheck, PenTool, Bot, Users];
const FEATURE_KEYS = ["f1","f2","f3","f4","f5","f6","f7","f8","f9","f10","f11","f12"];

export function AgencyFeatures() {
  const { t } = useI18n();
  return (
    <section id="agency-features" className="py-24 px-6 scroll-mt-20" style={{ backgroundColor: "#0c1d50" }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4 text-white">
            {t("agency.features.title")}
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: "#94a3b8" }}>
            {t("agency.features.desc")}
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {FEATURE_KEYS.map((k, i) => {
            const Icon = FEATURE_ICONS[i];
            return (
              <div key={k} className="p-7 rounded-3xl" style={{ backgroundColor: "#0e2058", border: "1px solid #163554" }}>
                <div className="w-12 h-12 rounded-2xl flex items-center justify-center mb-5" style={{ backgroundColor: "rgba(232,114,26,0.12)" }}>
                  <Icon className="w-6 h-6" style={{ color: "#e8721a" }} />
                </div>
                <h3 className="text-lg font-bold mb-2 text-white">{t(`agency.features.${k}.title`)}</h3>
                <p className="text-sm leading-relaxed" style={{ color: "#94a3b8" }}>{t(`agency.features.${k}.desc`)}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
